'use client'

import { useMemo, useState } from 'react'

import { useProduct } from '@/screens/Product/hooks/useProduct'

import { FullScreenModal } from '@/shared/ui/full-screen-modal'

import { DetailedSlider } from '../../ui/product-main/product-slider/components/detailed-slider/detailed-slider'
import { ThumbsGallery } from '../../ui/product-main/product-slider/components/thumbs-gallery/ThumbsGallery'
import { getProductSliderMedia } from '../../ui/product-main/product-slider/media'

import { DiscountBenefits } from './discount-benefits'

export const DiscountProductSlider = (): JSX.Element => {
	const { product } = useProduct()
	const media = useMemo(() => getProductSliderMedia(product.IMAGES, product.VIDEO), [product.IMAGES, product.VIDEO])
	const [isFullScreenModalOpen, setIsFullScreenModalOpen] = useState(false)
	const [activeSlide, setActiveSlide] = useState<number>()

	return (
		<>
			<ThumbsGallery
				title={product.TITLE}
				media={media}
				onClick={() => setIsFullScreenModalOpen(true)}
				setActiveSlide={setActiveSlide}
				sections={product.SECTIONS}
				bottomContent={<DiscountBenefits />}
			/>

			<FullScreenModal open={isFullScreenModalOpen} onClose={() => setIsFullScreenModalOpen(false)}>
				<DetailedSlider media={media} activeSlide={activeSlide} />
			</FullScreenModal>
		</>
	)
}
